import { RECORD_SOURCE } from '../../../../constants';

export const DEFAULT_ITEM_TEMPLATE = { source: RECORD_SOURCE.LOCAL };
